import { Button, Space } from "antd"
import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { URL_BACKEND } from "../../api/url"
import { useTabla } from "../../functions/useTabla"

export const useBachilleratos = () => {

    // constantes

    const [bachilleratos, setBachilleratos] = useState([])
    const sortDirections = ['ascend', 'descend']
    const { getColumnSearchProps } = useTabla()
    const [loading, setLoading] = useState( true )


    // funciones
    const traerBachilleratos = () => {

        let d = new FormData()
        d.append('funcion', 'traerBachilleratos')

        fetch( URL_BACKEND, {
            body: d,
            method: 'post'
        })
        .then( res => res.json() )
        .then( function( datos ) {
            setBachilleratos( datos )
        })
        .catch( () => alert("Error al traer bachilleratos") )
        .finally( () => setLoading( false ) )
    }

    // useEffects
    useEffect(() => {
        traerBachilleratos()
    }, [ ])

    // tabla
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nom_bachillerato',
            ...getColumnSearchProps('nom_bachillerato'),
            sorter: (a, b) => a.nom_bachillerato.localeCompare(b.nom_bachillerato),
            sortDirections
        },
        {
            title: 'Localidad',
            dataIndex: 'localidad',
            ...getColumnSearchProps('localidad'),
            sorter: (a, b) => a.localidad.localeCompare(b.localidad),
            sortDirections
        },
        {
          title: 'Acciones',
          render: (text, record) => (
            <Space size="middle">
              <Button type='link'>
                <Link to={`/bachilleratos/editar/${record.pk_bachillerato}`}>Editar</Link>
              </Button>
            </Space>
          ),
        },
    ];

    return {
        columns,
        bachilleratos,
        loading
    }
}
